import React, { Component } from 'react'
import { RTLButton } from '../RTLKit';
import {commonConstants} from "../../actions/commonActions";
import {API_FETCH} from "../../services/FetchService";
import {appLogout} from "../../services/AuthService";
import {connect} from "react-redux";
import {userConstants} from "../../constants";


/* -------- --------------  --------*/
/* -------  App Container   --------*/
/* -------- --------------  --------*/

const mapDispatchToProps = dispatch => ({

    onLogout : () => {
        dispatch(logoutFunc());
    },


    onPageLoad: () => {
        dispatch({type: commonConstants.PAGE_REDIERCT, redirectTo: '/login'})
    }
});


/* ------------------------------------------------ */
/* -------- Functions of mapDispatchToProps ------- */
/* ------------------------------------------------ */

const logoutFunc = () => {
    return (dispatch, getState) => {
        dispatch({type: userConstants.LOGOUT_REQUEST});
        API_FETCH.get('auth/sign_out').then(res => {
            appLogout();
            dispatch({type: userConstants.LOGOUT_SUCCESS});
        }).catch(error => {
            dispatch({type: userConstants.LOGOUT_FAILURE});
            console.log(error);
        });

    }
}

const mapStateToProps = state => ({
    alert: state.alert,
    auth: state.auth,
    common: state.common
})


/* ------- ------------- --------*/
/* ------- App Component --------*/
/* ------- ------------- --------*/

class Logout extends Component {
    constructor(props) {
        super(props);
    };

    componentWillMount() {
    };


    render () {
        var _self = this;//_self.setState
        return(
            <RTLButton loading={this.props.auth.isLogoutProgressing} shape="round" type="danger" icon="logout" style={{marginRight: '10px'}} onClick={this.props.onLogout }>خروج</RTLButton>
        );
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Logout);


